import { FormModel } from 'common/form-state-manager/FormModel'
import { IsNotEmpty } from 'common/validation/decorators/IsNotEmpty'

export class ReferralProgramThanksFormModel extends FormModel {

    @IsNotEmpty()
    thanksMessage: string

    @IsNotEmpty()
    inviteMessage: string

    constructor(initialData?: any) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
